import { ReactNode } from "react";

export const NavigationItem = ({ children }: { children: ReactNode }) => {
  return <div className="relative flex items-center h-full">{children}</div>;
};
